/*
 *
 * Staff constants
 *
 */

export const DEFAULT_ACTION = 'app/Staff/DEFAULT_ACTION';
